import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, OutlinedInput } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { AppBarProps, AppBar as RaAppBar } from 'react-admin'
import { color, xxllncColor } from './themes'
import { UserMenu } from './UserMenu'

const AppBar: FC<AppBarProps> = (props) => (
  <StyledAppBar
    className={classes.root}
    container='div'
    elevation={1}
    userMenu={<UserMenu />}
    {...props}
  >
    <div className={classes.headerContainer}>
      <h1 className={classes.appLogo}>
        <span className={classes.vignet} aria-hidden="true">Md</span>
        <span className={classes.appName}>Meldingen</span>
      </h1>
    </div>

    <span className={classes.spacer} />

    {/* Search - nog in eigen component zetten */}
    {/* <OutlinedInput
      type="search"
      size="small"
      sx={{ backgroundColor: '#fff' }}
      placeholder="Zoeken in Supportpoc"
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
    /> */}
  </StyledAppBar>
)

const PREFIX = 'xxllncAppBar'

const classes = {
  root: `${PREFIX}-root`,
  spacer: `${PREFIX}-spacer`,
  headerContainer: `${PREFIX}-headerContainer`,
  appLogo: `${PREFIX}-appLogo`,
  appName: `${PREFIX}-appName`,
  vignet: `${PREFIX}-vignet`,
}

const StyledAppBar = styled(RaAppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: color.white,
  },
  ['& .RaAppBar-toolbar']: {
    height: theme.spacing(4),
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.headerContainer}`]: {
    maxWidth: '10rem',
    flex: 1,
  },
  [`& .${classes.appLogo}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontSize: '0.8rem',
    fontWeight: 500,
  },
  [`& .${classes.vignet}`]: {
    backgroundColor: xxllncColor.yellow100,
    color: '#000',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '2rem',
    width: '2rem',
    borderRadius: '0.5rem',
  },
  [`& .${classes.appName}`]: {
    color: color.white,
    fontSize: '0.8rem',
  },
}))

export default AppBar
